/* global
AP
*/

import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { fetchExampleMapAsync } from '../../actioncreators/actioncreators'
import queryString from 'query-string'

const { Component } = React

const Panel = styled.div`
  width: 48%;
  margin-right: 2%;
  margin-bottom: 2%;
  border-width: 1;
  border-radius: 2px;
  border-color: #aaa;
  box-shadow: 0px 1px 2px 0px rgba(9, 30, 66, 0.25);
  padding: 10px;
  background-color: #fff;
`
const RuleText = styled.div`
  border: solid 5px #0C8CE6;
  border-width: 0 0 0 5px;
  padding-left:10px;
  font-weight: bold;
`

const Example = styled.div`
  margin-top:10px;
  border: solid 5px #14B300;
  border-width: 0 0 0 5px;
  padding-left: 10px;
`

const QuestionText = styled.div`
  border: solid 5px #FF3B26;
  border-width: 0 0 0 5px;
  padding-left:10px;
  font-weight: bold;
`

class Editor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      appLicensed: true
    }
  }

  componentWillMount () {
    const parsed = queryString.parse(window.location.search)
    if (parsed.lic !== 'active') {
      this.setState({ appLicensed: false })
      return
    }
    this.props.fetchExampleMap()
  }

  render () {
    let allRules = []
    let ruleCounter = 0

    this.props.rules.forEach((ruleRow) => {
      let rules = ruleRow.map((rule) => {
        let examples = rule.examples.map((example, exampleIndex) => {
          return (
            <Example key={exampleIndex}>
              {example.text.length > 0 ? example.text : String.fromCharCode(160)}
            </Example>
          )
        })

        ruleCounter++

        return (
          <Panel key={ruleCounter}>
            <div key={ruleCounter}>
              <RuleText>
                {rule.text.length > 0 ? rule.text : String.fromCharCode(160)}
              </RuleText>
              <div>
                {examples}
              </div>
            </div>
          </Panel>
        )
      })
      allRules.push(rules)
    })

    let questions = this.props.questions.map((question, questionIndex) => {
      return (
        <Panel>
          <QuestionText>
            {question.text.length > 0 ? question.text : String.fromCharCode(160)}
          </QuestionText>
        </Panel>
      )
    })

    return <div>
      <p style={{ display: this.state.appLicensed ? 'none' : 'block' }}>Example Mapping for Jira is not currently licensed.</p>
      <div style={{ display: this.state.appLicensed ? 'block' : 'none' }}>
        <div style={{ display: this.props.rulesPresent ? 'none' : 'block' }}>
          <button onClick={this.props.openDialog} className='btn btn-default'>Create Example Map</button>
        </div>
        <div style={{ display: this.props.rulesPresent ? 'block' : 'none' }}>
          <button onClick={this.props.openDialog} className='btn btn-default'>Edit Example Map</button>
          <div style={{ marginTop: 10, display: 'flex', flexFlow: 'row wrap', backgroundColor: '#f4f5f7', paddingLeft: '1.5%', paddingTop: '1.5%' }}>
            {allRules}
          </div>
          <div style={{ display: 'flex', flexFlow: 'row wrap', backgroundColor: '#f4f5f7', paddingLeft: '1.5%', paddingTop: '1.5%' }}>
            {questions}
          </div>
        </div>
      </div>
    </div>
  }
}

const mapStateToProps = function (store, ownProps) {
  let numberOfRules = 0
  store.rules.forEach(row => {
    numberOfRules += row.length
  })
  return {
    rules: store.rules,
    questions: store.questions,
    rulesPresent: numberOfRules > 0
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    fetchExampleMap: () => dispatch(fetchExampleMapAsync()),
    openDialog: () => {
      window.amplitude.getInstance().logEvent('em_open_editor')
      AP.require('dialog', function (dialog) {
        dialog.create({
          key: 'dialog-module-em-edit',
          chrome: false,
          width: '100%',
          height: '100%',
          size: 'maximum'
        }).on('close', () => {
          dispatch(fetchExampleMapAsync())
        })
      })
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor)
